import { defineMessages } from 'react-intl';

export default defineMessages({
  TOOLTIP: {
    defaultMessage: 'Votre profil',
  },
} as const);
